import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = {
  key: 0,
  class: "contentBox"
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "text-grey ml-2 mt-1.5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "providerDetailBox" }
const _hoisted_9 = { class: "providerDetailBox" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "providerDetailBox" }
const _hoisted_12 = { class: "showDetails" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "showDetails" }
const _hoisted_15 = { class: "block w-full" }
const _hoisted_16 = { class: "flex mb-4" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["disabled", "title"]
const _hoisted_19 = { class: "ml-auto" }
const _hoisted_20 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref, watchEffect} from "vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {useGlobalStore} from "@/stores/GlobalStore";
import {ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import {$t} from "@/utilities/i18n/config";
import {PermissionService} from "@/utilities/services/PermissionService";
import dialog from "@/dialog";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {GeneralResponse} from "@/models/api/Responses";
import Error from "@/components/Error";
import {useI18n} from "vue-i18n";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import router from "@/router";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {CompanyWorkerInfo} from "@/models/company/CompanyWorkerInfo";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import {CompanyWorkerService} from "@/utilities/services/entities/CompanyWorkerService";
import {CompanyService} from "@/utilities/services/entities/CompanyService";



export default /*@__PURE__*/_defineComponent({
  __name: 'ProviderDetails',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();

let showCompanyDetails = ref(false);
let selectedCompanyWorkers = ref([]);
const selectedCompany = ref(undefined);

const { t } = useI18n();
const companyWorkerService = new CompanyWorkerService();
const companyService = new CompanyService();
const permissionService = new PermissionService();

const currentWindowHeight = ref("");
const recalcGridHeight = (offset: number = 110) => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage-offset}px`;
};

const deleteSelection = async() => {
  //drop call without selection
  if(!selectedCompanyWorkers.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t("global.delete"))
      .cancelText(t("global.cancel"))
      .confirm(t("providerManagementDetails.confirmDeletionMulti", { count:selectedCompanyWorkers.value.length}));

  if (answer) {
    let someEntriesFailed = false;
    for (const cw of selectedCompanyWorkers.value){
      const resp = await companyWorkerService.deleteCompanyWorker(selectedCompany.value.id, cw.id);

      if(resp === null || resp === undefined || resp?.statusCode !== 0){
        ErrorHandler.handleError(resp, ErrorLocationType.table);
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:cw.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("global.deleted"));
  }
};

const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  relayStoreEvents: true,
	cellTooltipFeature: {
		hoverDelay      : 300,
		textContent     : true,
		hideOnDelegateChange: true,
	},
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'firstName',
        field: 'firstName',
        text: t('providerManagementDetails.grid.name'),
        flex: 1,
        type: 'template',
        template: ({record})=>{
					return StringHelper.xss`${record.data.firstName ?? ""} ${record.data.lastName ?? ""}`;
        }
      },
      {
        id:'isAdmin',
        field: 'isAdmin',
        text: t('providerManagementDetails.grid.admin'),
        width: 100,
        type: "template",
        template: ({record}) => {
          return record.data.isAdmin ? `<span class='adminBox'>Admin</span>` : "";
        },
      },
      {
        id:'email',
        field: 'email',
        text: t('providerManagementDetails.grid.email'),
        flex: 1
      },
      {
        id:'phoneNumber',
        field: 'phoneNumber',
        text: t('providerManagementDetails.grid.phoneNumber'),
        flex: 1,
        type: 'template',
        template: ({record})=>{
					return StringHelper.xss`${record.data.dialCode ?? ""}${record.data.phoneNumber ?? ""}`;
        }
      },
      {
        id:'anAbSystem.userConfirmationExpired',
        field: 'anAbSystem.userConfirmationExpired',
        text:  t('providerManagementDetails.grid.active'),
        width   : 36,
        type: "template",
        template: ({record}) => {
          return record.data.anAbSystem?.userConfirmationExpired
              ? `<span class='icon-status_bald_inaktiv text-red biggerGridIcon'></span>`
              : `<span class='icon-status_aktiv text-green biggerGridIcon'></span>`;
        },
      },
      {
        id:'isEnabled',
        field: 'isEnabled',
        text: t('providerManagementDetails.grid.cleared'),
        width: 100,
        type: "template",
        template: ({record}) => {
          let outputString = "";
          if(permissionService.userHasPermission("ProviderManagementPolicy.CompanyWorker.Edit")) {
            outputString = record.data.isEnabled
                ? `<input type="checkbox" class="switch" checked/>` // id="isEnabledSwitch" value="${record.data.userId}"
                : `<input type="checkbox" class="switch" />`;
          } else {
            outputString = `<input type="checkbox" class="switch" disabled />`;
          }

          return outputString;
        },
      },
			{
				id: 'info',
				field: 'info',
				text: "",
				width: 60,
				sortable: false,
				resizable: false,
				minWidth: 60,
				type: "template",
				tooltipRenderer: ({record}) => {
						return StringHelper.xss`${record.data.userInfo ?? ""}`
				},
				template: ({record}) => {
					if(!NullOrUndefinedHelper(record.data.userInfo)) {
						return `<div class="gridTooltipButton"><span class="icon-info text-blue"></span></div>`;
					}
				},
			},
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.providerStaff], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedCompanyWorkers.value = selectedCompanyWorkers.value.concat(event.selected.map(cwr => cwr.data))
      selectedCompanyWorkers.value = selectedCompanyWorkers.value.filter(cw => !event.deselected.map(cwr => cwr.data).some(cwr => cw?.id === cwr?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    async cellClick({column, record}) {
      if (column.data.field === 'anAbSystem.userConfirmationExpired') {
        if(record.data.anAbSystem.userConfirmationExpired){
          const resp = await companyWorkerService.postResetExpirationForCompanyWorker(selectedCompany.value.id, record.data.userId);
          record.data.anAbSystem.userConfirmationExpired = resp === null || resp === undefined || resp.statusCode !== 0;
          gridStore.add(record);
        }
      }
      if(column.data.field === 'isEnabled'){
        record.data.isEnabled = !record.data.isEnabled;
        const resp = await companyWorkerService.postSetCompanyWorkerEnabled(record.data.userId, record.data.isEnabled);
        record.data.isEnabled = resp === null || resp === undefined || resp.statusCode !== 0;
        gridStore.add(record);
      }
    },
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t("providerManagementDetails.grid.reactivate"),
        disabled: !record.anAbSystem.userConfirmationExpired,
        cls: 'color',
        icon: 'icon-person',
        weight: 100,
        onItem : async ({record}) => {
          const resp = await companyWorkerService.postResetExpirationForCompanyWorker(selectedCompany.value.id, record.data.userId);
          record.data.anAbSystem.userConfirmationExpired = resp === null || resp === undefined || resp.statusCode !== 0;
          gridStore.add(record);
        }
      },
      {
        text: t("global.edit"),
        hidden: !permissionService.userHasPermission("ProviderManagementPolicy.CompanyWorker.Edit"),
        cls: 'color',
        icon: 'icon-editieren',
        weight: 100,
        onItem : ({ menu }) => {
          globalStore.openPopup({
            data: menu.record,
            action:addOrUpdateCompanyWorker,
            resetButton:false,
            title:$t("popups.providerManagementDetails.edit"),
            type:PopupType.providerCompanyWorkerEditPopup
          });
        }
      },
      {
        text   : t("global.delete"),
        disabled: !permissionService.userHasPermission("ProviderManagementPolicy.Delete"),
        hidden: false,
        cls	: 'color',
        icon: 'icon-loeschen',
        weight : 140,
        onItem: async ({ menu }) => {
          const answer = await dialog
              .okText(t("global.delete"))
              .cancelText(t("global.cancel"))
              .confirm(t("providerManagementDetails.confirmDeletionSingle", {name: `${menu.record.firstName} ${menu.record.lastName}`}));

          if (answer) {
            const resp = await companyWorkerService.deleteCompanyWorker(selectedCompany.value.id, menu.record.id ?? menu.record.userId);

            if(resp === null || resp === undefined || resp?.statusCode !== 0){
              ErrorHandler.handleError(resp, ErrorLocationType.table);
              return;
            }

            gridStore.applyChangeset({removed:[{id:menu.record.id}]});

            globalStore.showSuccess(t('global.deleted'));
          }
        }
      }
    ],
  });

  menu.setRecord(record);

  return menu;
};

const newCompanyWorker = () => {
  globalStore.openPopup({
    data: new CompanyWorkerInfo(),
    action: checkForExistingPhoneNumber,
    resetButton: false,
    title:$t("popups.providerManagementDetails.new"),
    type:PopupType.providerNewCompanyWorkerPopup
  });
}

// CAUTION: missusing userInfo prop here to show messages from api and clearing it before proceeding to edit new cw
const checkForExistingPhoneNumber = async ()=>{
  globalStore.modal.contentObject.userInfo = "";

  const companyWorker = globalStore.modal.contentObject as CompanyWorkerInfo;

  const foundCompanyWorkerResp = await companyWorkerService.postSearchCompanyWorkerByPhonenumber(selectedCompany.value.id, companyWorker.dialCode, companyWorker.phoneNumber);
  if (foundCompanyWorkerResp === null || foundCompanyWorkerResp === undefined || foundCompanyWorkerResp.statusCode !== 0){
    ErrorHandler.handleError(foundCompanyWorkerResp, ErrorLocationType.popup);
    return;
  }

  if (foundCompanyWorkerResp.statusMessage !== ""){
    if(!NullOrUndefinedHelper(foundCompanyWorkerResp.user)){
      foundCompanyWorkerResp.user.id = foundCompanyWorkerResp.user?.userId;
      gridStore.add(foundCompanyWorkerResp.user);

      globalStore.closeModal()
      globalStore.showSuccess($t('providerManagementDetails.connectedWorker'))
    }
    globalStore.modal.contentObject.userInfo = foundCompanyWorkerResp.statusMessage;

    return;
  }

  globalStore.modal.contentObject.userInfo = "";
  const user = globalStore.modal.contentObject;


  globalStore.openPopup({
    data: user,
    action: addOrUpdateCompanyWorker,
    resetButton: false,
    title:$t("popups.providerManagementDetails.new"),
    type:PopupType.providerCompanyWorkerEditPopup
  });
}

const addOrUpdateCompanyWorker = async () => {
  const companyWorker = globalStore.modal.contentObject as CompanyWorkerInfo;

  const companyWorkerResponse = await companyWorkerService.addorUpdateCompanyWorker(selectedCompany.value.id, companyWorker);
  if (companyWorkerResponse === null || companyWorkerResponse === undefined || companyWorkerResponse.statusCode !== 0){
    ErrorHandler.handleError(companyWorkerResponse as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  if(companyWorker.id === "") {
    companyWorker.id = companyWorkerResponse.userId;
    companyWorker.userId = companyWorkerResponse.userId;
  }
  // fix selection when it was an update -> replace old value in selected-array
  else if(selectedCompanyWorkers.value.some(el => el.id === companyWorker.id)) {
    selectedCompanyWorkers.value = selectedCompanyWorkers.value.filter(el => el.id !== companyWorker.id);
    selectedCompanyWorkers.value.push(companyWorker);
  }

  gridStore.add(companyWorker);
  gridStore.sort(gridStore.sorters);

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
}

const setGridData = async ()=>{
  // start spinner
  globalStore.gridDataIsLoading = true;

  const companyWorkerResp = await companyWorkerService.getCompanyWorkerInfoForCompany(selectedCompany.value.id);
  if (companyWorkerResp === null || companyWorkerResp === undefined || companyWorkerResp.statusCode !== 0) {
    ErrorHandler.handleError(companyWorkerResp, ErrorLocationType.table);
    return;
  }

  gridStore.setStoreData(companyWorkerResp.companyWorkers.map(cw =>{
    cw.id = cw.userId;
    return cw;
  }));

  selectedCompany.value.hasAdmin = companyWorkerResp.companyWorkers.some(cw => cw.isAdmin);

  globalStore.reorderColumns(TableType[TableType.providerStaff]);

  // stop spinner
  globalStore.gridDataIsLoading = false;
};


onMounted(async () => {
  // start spinner
  globalStore.gridDataIsLoading = true;
  const selectedCompanyResp = await companyService.getCompanyById(router.currentRoute.value.params.id as string);

  //@ts-expect-error
  selectedCompany.value = selectedCompanyResp.companyInfo;
  // stop spinner
  globalStore.gridDataIsLoading = false;

  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData();
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

watchEffect(()=>{
  if (showCompanyDetails.value) recalcGridHeight(195)
  else recalcGridHeight()
})

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("providerManagementDetails.title")), 1)
    ]),
    (selectedCompany.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(router).back && _unref(router).back(...args)))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "smallIcon icon-pfeil-links iconInButton" }, null, -1)),
                _createElementVNode("div", null, _toDisplayString(_unref($t)("providerManagementDetails.backButton")), 1)
              ])
            ]),
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref($t)("providerManagementDetails.headline")) + " " + _toDisplayString(selectedCompany.value.name), 1)
          ]),
          _createElementVNode("div", {
            class: "providerDetails",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(showCompanyDetails) //@ts-ignore
 ? showCompanyDetails.value = !_unref(showCompanyDetails) : showCompanyDetails = !_unref(showCompanyDetails)))
          }, [
            (_unref(showCompanyDetails))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("strong", null, _toDisplayString(_unref($t)("providerManagementDetails.address")), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCompany.value.street) + " " + _toDisplayString(selectedCompany.value.streetnumber), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCompany.value.zip) + " " + _toDisplayString(selectedCompany.value.city), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("strong", null, _toDisplayString(_unref($t)("providerManagementDetails.contact")), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCompany.value.contactPersonName), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCompany.value.contactPersonPhoneNumber), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("a", {
                        href: 'mailto:'+selectedCompany.value.contactPersonEmail
                      }, _toDisplayString(selectedCompany.value.contactPersonEmail), 9, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("strong", null, _toDisplayString(_unref($t)("providerManagementDetails.information")), 1),
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(selectedCompany.value.info), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_unref($t)("providerManagementDetails.lessInfos")) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "smallIcon icon-pfeil-hoch" }, null, -1))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref($t)("providerManagementDetails.moreInfos")) + " ", 1),
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "smallIcon icon-pfeil-runter" }, null, -1))
                  ])
                ]))
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_unref(Error), {
              errorLoc: _unref(ErrorLocationType).table
            }, null, 8, ["errorLoc"]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "primary mr-2",
                  onClick: newCompanyWorker,
                  title: _unref(t)('providerManagementDetails.new')
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("span", { class: "icon-neu" }, null, -1)
                ]), 8, _hoisted_17)), [
                  [_directive_permission, 'ProviderManagementPolicy.CompanyWorker.Create']
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "primary mr-2",
                  disabled: !_unref(selectedCompanyWorkers).some(()=>true),
                  onClick: deleteSelection,
                  title: _unref(t)('global.delete')
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("span", { class: "icon-loeschen" }, null, -1)
                ]), 8, _hoisted_18)), [
                  [_directive_permission, 'ProviderManagementPolicy.CompanyWorker.Delete']
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(GridInputFilter), {
                    gridStore: _unref(gridStore),
                    hideFilterButton: true
                  }, null, 8, ["gridStore"])
                ])
              ]),
              _createVNode(_unref(BryntumGrid), _mergeProps({
                ref_key: "grid",
                ref: grid
              }, gridConfig, { readOnly: true }), null, 16)
            ])
          ], 512), [
            [_vShow, !_unref(globalStore).gridDataIsLoading]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createVNode(LoadingSpinner)
          ], 512), [
            [_vShow, _unref(globalStore).gridDataIsLoading]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})